import React, { useEffect, useMemo, useState } from 'react'

import PropTypes from 'prop-types';
import { Field, Form } from 'react-final-form';
import { connect } from 'react-redux';

﻿import Button from 'components/Button/Button';
import FormField from 'components/FormField/FormField';
import FormSwitch from 'components/FormSwitch/FormSwitch';
import Modal from 'components/Modal/Modal';
import { BusinessCategoriesField, CouponCategoryField } from 'containers';
import { AFFILIATE_TYPES } from 'coupon-common';
import { actions as affiliateActions } from 'coupon-common/src/modules/affiliateBusiness';
import { dispatchAsAsync, required } from 'coupon-common/src/utils';


const AffiliateBusinessModal = ({ isOpen, onClose, business, dispatch, defaultAffiliateType }) => {
  const [logoFile, setLogoFile] = useState(null);
  const [coverImageFile, setCoverImageFile] = useState(null);

  const initialValues = useMemo(() => {
    return business || {
      name: '',
      logo: '',
      cover_image: '',
      business_web_url: '',
      terms_and_conditions: '',
      is_flyer: false,
      is_affiliate: false,
      affiliate_code: '',
      affiliate_type: defaultAffiliateType || AFFILIATE_TYPES.custom,
      categories: []
    };
  }, [business, defaultAffiliateType]);


  const handleSave = async (data) => {
    // console.log('data is ' + JSON.stringify(data));
    const action = business?.id ? affiliateActions.updateAffiliateBusiness(business.id, data) : affiliateActions.createAffiliateBusiness(data)

    const response = await dispatchAsAsync(action, dispatch);

    if (response?.success) {
      if (business?.id) {
        alert("Business has been successfully updated")
      }
      else {
        alert("Business has been successfully created")
      }
      onClose();
      dispatch(affiliateActions.getAffiliateBusinesses());
    }
    else {
      alert(`An error occurred while trying to create/update the business. Details: ${response?.error}`)
    }
  };

  const handleDelete = (id) => {
    const confirm = window.confirm("Are you sure you want to delete this business ?")
    if (confirm) {
      dispatch(affiliateActions.deleteAffiliateBusiness(id));
      onClose();
    }
  };

  const handleSubmit = async (values) => {
    const formData = new FormData();

    // Append text fields
    console.log("val", values);


    for (const [key, value] of Object.entries(values)) {
      if (key === 'categories') {
        if (value[0]?.id) {
          const categoryId = value[0].id
          formData.append('categories', categoryId);
        }

      } else if (typeof value === 'boolean') {
        formData.append(key, value.toString());
      }
      else if (key === 'subcategories') {
        for (const subCat of value) {
          formData.append('subcategories', subCat?.id);
        }
      }
      // else if (key === 'logo' || key === 'cover_image') {
      //   // Append file fields only if the file is selected
      //   if (key === 'logo') {
      //     if (logoFile) {

      //       formData.append('logo', logoFile);
      //     }
      //     else if (business?.logo && typeof business.logo === 'string') {
      //       try {
      //         const response = await fetch(business.logo, { mode: 'cors' });  // CORS required if image is from external domain
      //         if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      //         console.log("res", response);


      //         const blob = await response.blob();
      //         console.log("blob", blob);

      //         const fileName = business.logo.split('/').pop() || 'logo.jpg';
      //         const file = new File([blob], fileName, { type: blob.type });

      //         formData.append('logo', file);  // ✅ Correct usage here
      //       } catch (err) {
      //         console.error('Failed to fetch logo from URL:', err);
      //       }
      //     }
      //   }
      //   else if (key === 'cover_image' && coverImageFile) {
      //     formData.append('cover_image', coverImageFile);
      //   }
      // }
      else {
        formData.append(key, value);
      }
    }

    handleSave(formData);
  };

  return (
    <Modal
      title={business ? 'Edit Affiliate Business' : 'Add Affiliate Business'}
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <Form
        key={business?.id || 'new'}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        render={({ handleSubmit, values }) => (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 10 }}>
              <Field
                name="name"
                label="Name"
                component={FormField}
                validate={required}
                type="text"
              />
            </div>

            <div style={{ marginBottom: 10 }}>
              <Field
                name="logo"
                label="Logo"
                component={FormField}
                validate={required}
                type="text"
              />
            </div>
            <div style={{ marginBottom: 10 }}>
              <Field
                name="cover_image"
                label="cover_image"
                component={FormField}
                type="text"
              />
            </div>



            <div style={{ marginBottom: 10 }}>
              <Field
                name="business_web_url"
                label="Business Website URL"
                component={FormField}
                type="text"
                maxlength={500}
              />
            </div>

            <div style={{ marginBottom: 10 }}>
              <Field
                name="terms_and_conditions"
                label="Terms and Conditions"
                component={FormField}
                type="text"
              />
            </div>

            <div style={{ marginBottom: 10 }}>
              <Field
                name="affiliate_code"
                label="Affiliate Code"
                component={FormField}
                // validate={required}
                type="text"
              />
            </div>

            <div style={{ marginBottom: 10 }}>
              <Field
                name="affiliate_type"
                label="Affiliate Type"
                component={FormField}
                type="text"
                // validate={required}
                tooltip="Valid options: CUSTOM, IMPACT, CJ, AWIN, RAKUTEN"
              />
            </div>

            <div style={{ marginBottom: 10, maxWidth: '600px' }}>
              <BusinessCategoriesField />
            </div>
            <div style={{ marginBottom: 10 }}>
              <Field
                name="is_flyer"
                type="checkbox"
                label={"Is Flyer"}
                component={FormSwitch}
              />
            </div>

            <div style={{ marginBottom: 10 }}>
              <Field
                name="is_affiliate"
                // type="checkbox"
                component={FormSwitch}
                // component={FormField}
                // type="text"
                label={"Is Affiliate"}
              />
            </div>

            {/* <FormSwitch
            label={"Test"}
            checked={true}
            // onChange={val => {
            //   const next = { ...cd, redeemableWithPoints: val };
            //   // convenience: if turning ON points, prefer manual acceptance by default
            //   if (val && next.redemptionType !== 'manual')
            //     next.redemptionType = 'manual';
            //   setCouponData(next);
            // }}
          /> */}

            <div style={{ marginTop: 20 }}>
              <Button type="submit">Save</Button>
              {business?.id && (
                <Button
                  outline
                  type="button"
                  // onClick={() => onDelete(business.id)}
                  onClick={() => handleDelete(business.id)}
                  style={{ marginLeft: 10 }}
                >
                  Delete
                </Button>
              )}
            </div>
          </form>
        )}
      />
    </Modal>
  );
};

AffiliateBusinessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  business: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  defaultAffiliateType: PropTypes.string,
};


export default connect()(AffiliateBusinessModal);
